import script from "./referenceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./referenceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./referenceDetailPage.vue?vue&type=style&index=0&id=2c7c423c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7c423c"]])

export default __exports__